import React, { useState } from "react";
import { Button, Row, Col, Form, Input, notification } from "antd";
import ClipLoader from "react-spinners/ClipLoader";
import { forgotPasswordStyles } from "./ForgotPasswordStyles";
import ava1 from "../../assets/images/my-friend-logo-blue.svg";
import rules from "../../validations";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "../../api/password";
import Footer from "../../components/layout/Footer";
import constants from "../../constants/constants";

export const ForgotPassword = () => {
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const onFinish = async () => {
    setLoader(true);
    try {
      const response = await sendPasswordResetEmail({ email });
      setLoader(false);
      if (response.error) {
        notification.error({
          message: "Error",
          description: response.error,
        });
      } else {
        notification.success({
          message: "Success",
          description: constants.emailSent,
        });
        navigate("/signin");
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message,
      });
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div style={{ maxHeight: "100dvh", overflow: "hidden" }}>
      <Row>
        <Col lg={24} md={24} xs={24}>
          <div style={forgotPasswordStyles.containerA}>
            <div style={forgotPasswordStyles.containerB}>
              <div style={forgotPasswordStyles.logoContainer}>
                <img
                  style={forgotPasswordStyles.logoStyle}
                  src={ava1}
                  alt="logo"
                />
              </div>
              <div style={forgotPasswordStyles.marginAuto}>
                <span style={forgotPasswordStyles.signInHeading}>
                  Forgot Password
                </span>
              </div>
              <div style={forgotPasswordStyles.marginAuto}>
                <span style={forgotPasswordStyles.signInDescription}>
                  Enter your email to reset your password
                </span>
              </div>
              <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
              >
                <Form.Item
                  className="forgot-password-email"
                  label="Email"
                  name="email"
                  rules={rules.email}
                  style={forgotPasswordStyles.formInput}
                >
                  <Input
                    placeholder="Email"
                    maxLength={255}
                    type="email"
                    onChange={handleChange}
                  />
                </Form.Item>
                <Form.Item style={forgotPasswordStyles.centerFormButton}>
                  <Row gutter={16} align="center">
                  <Col xs={13} sm={13} md={12} lg={12}>
                      <Button
                        type="primary"
                        onClick={() => navigate("/signin")}
                        style={forgotPasswordStyles.forgotButton}
                      >
                        Back to Sign In
                      </Button>
                    </Col>

                    <Col xs={11} sm={11} md={12} lg={12}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={forgotPasswordStyles.signInButton}
                      >
                        {loader ? (
                          <ClipLoader
                            color="#fff"
                            loading={loader}
                            size={15}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        ) : (
                          <span>Send Email</span>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
      <Row style={forgotPasswordStyles.fixFooter}>
        <Col xs={24}>
          <Footer />
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPassword;